<template lang="pug">
  a(:class="lang", :href="path")
    img#logo(alt='MEDITECH FINDER LOGO', width='306', height='30', src='images/img_logo.png')
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    data: function(){
      return {
        ja_path: '/',
        en_path: '/en/'
      }
    },
    computed: {
      ...mapState([
        'lang'
      ]),
      path: function(){
        if(/ja/.test(this.lang)){
          return this.ja_path;
        }else{
          return this.en_path;
        }
      },
    }

  };

</script>
<style lang="sass">
  #logo
    float: left
</style>
